<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'grey darken-2'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.unlock')"
        :icon="error ? 'mdi-alert' : 'mdi-lock-open-variant'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnUnlock',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>